export default "__VITE_ASSET__D1402aK9__"